import { FilterMenuItemType, FilterMenuType } from "./FilterMenu.model";
import { ActiveFilterItem } from "./active-filter-item/ActiveFilterItem";
import { FieldFilter } from "./FieldFilter.model";

interface ActiveFiltersProps<Test extends Record<string, FieldFilter>> {
  size?: "1" | "2" | "3";
  value: Partial<Test>;
  menu: FilterMenuType<Extract<keyof Test, string>>;
  viewOnly?: boolean;
  onChange: (item: FilterMenuItemType<Extract<keyof Test, string>>) => void;
}

export function ActiveFilters<Test extends Record<string, FieldFilter>>({
  size = "1",
  value,
  menu,
  viewOnly = false,
  onChange,
}: ActiveFiltersProps<Test>) {
  return (
    <>
      {Object.entries(value).map(([field]) => {
        const fieldValue = value[field];
        // Exact match first, then try stripping composite suffix (e.g. "field::gte" → "field")
        const baseField = field.replace(/::(?:gte|lte)$/, "");
        const item =
          menu.find((item) => item.field === field) ??
          menu.find((item) => item.field === baseField);

        if (fieldValue == null || !item) return <></>;

        // Pass the actual composite key so onChange/clear targets the right entry
        const itemWithKey = field !== item.field ? { ...item, field } as typeof item : item;

        return (
          <ActiveFilterItem
            size={size}
            key={field}
            item={itemWithKey}
            value={fieldValue}
            viewOnly={viewOnly}
            onChange={onChange}
          />
        );
      })}
    </>
  );
}
